<script>
  import { userStores } from "@stores/index.js";
  import { ROUTES } from "@utils/routes.js";
  import { fetchWithSession } from "../../../lib/util/fetchWithSession.js";
  import { Link } from "svelte-navigator";
  import ArrowIcon from "./svg/ArrowIcon.svelte";
  import Header from "lib/components/Header.svelte";
  import { Button } from "paxray-components-svelte";
  import { ARROW_LEFT_ICON } from "@utils/icons.js";
  import { onMount } from "svelte";
  // import { permissionsListStore } from "@stores/settingsStores.js";

  let permissions = [];

  $: setPermissions($userStores?.groups);
  $: visiblePermissions = permissionsList.filter((p) =>
    permissions.includes(p.permissionId),
  );

  let permissionsList = [
    {
      title: "User Management",
      description: "Manage your accounts and their priviledges.",
      href: ROUTES.settings.userManagement,
      permissionId: "manage_users",
    },
    {
      title: "Permission Management",
      description: "Manage your permissions.",
      href: ROUTES.settings.permissionManagement,
      permissionId: "manage_groups",
    },
    {
      title: "Team Management",
      description: "Manage your platform teams priviledges.",
      href: ROUTES.settings.teamManagement,
      permissionId: "manage_teams",
    },
    {
      title: "Data Management",
      description: "Manage your platform process accessibility.",
      href: ROUTES.settings.dataManagement,
      permissionId: "manage_processes",
    },
  ];

  function setPermissions(groups) {
    permissions = new Set();
    groups
      ?.map((group) => group.permissions)
      .forEach((perms) => {
        perms.forEach((p) => permissions.add(p));
      });
    permissions = Array.from(permissions);
  }

  $$restProps;
</script>

<Header section="Settings" area="Settings" breadcrumb="">
  <Button kind="secondary" iconLeft={true} icon={ARROW_LEFT_ICON} text="Back" />
</Header>

<section>
  <ul>
    {#each visiblePermissions as permission, idx}
      <li class:list-btn={true}>
        <!-- <a href = {"/app/settings/"+permission.id.split("_")[1].slice(0, -1)+"-management"}> -->
        <Link to={permission.href}>
          <div class="link">
            <div class="list-item">
              <h1 class="index">{idx + 1 < 10 ? "0" + (idx + 1) : idx + 1}</h1>
              <div class="item-content">
                <h3 class="list-title">{permission.title}</h3>
                <span class="list-description">{permission.description}</span>
              </div>
            </div>
            <div class="arrow-styles">
              <ArrowIcon />
            </div>
          </div>
        </Link>
      </li>
    {/each}
  </ul>
</section>

<style>
  section {
    background: var(--pax-smoke);
    width: 100%;
    height: 100%;
    padding: 12px;
  }

  ul {
    display: grid;
    gap: 12px;
  }

  .link {
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  li {
    border-radius: 5px;
    cursor: pointer;
    background: var(--pax-white);
    padding: 10px 20px;
    border: 1px solid transparent;
    transition: border-color 0.3s ease;
  }
  li:hover {
    border-color: var(--pax-black);
  }

  .arrow-styles {
    display: none;
  }

  li:hover .arrow-styles {
    display: inline;
  }

  .index {
    color: var(--pax-smoke);
    font-family: Inter;
    font-size: 36px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    transition: color 0.3s ease;
  }
  .list-btn:hover .index {
    color: var(--pax-black);
  }

  .list-btn h3 {
    overflow: hidden;
    color: var(--pax-black);
    text-overflow: ellipsis;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  .list-btn span {
    color: var(--pax-black);
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: normal;
  }
  .list-item {
    display: flex;
    align-items: center;
    gap: 22px;
  }
  /* 
  .list-btn.disable {
    pointer-events: none;
    opacity: 0.5;
  } */
</style>
